import React from "react";

import { Navigate } from "react-router-dom";
import tokenService from "../utils/tokenService";

const ProtectedRoute = ({ children }) => {
  const token = tokenService.getAccessToken();
  if (token) {
    return children;
  } else {
    return <Navigate to="/login" />;
  }
};

export default ProtectedRoute;
